import { AbstractBprocRequest } from "./AbstractBprocRequest";
import { PersonGroupExt } from "./base$PersonGroupExt";
import { DicIndustry } from "./base$DicIndustry";
import { DicRequestStatus } from "./tsadv$DicRequestStatus";
import { FileDescriptor } from "./sys$FileDescriptor";
export class PersonExperienceRequest extends AbstractBprocRequest {
  static NAME = "tsadv_PersonExperienceRequest";
  personGroup?: PersonGroupExt | null;
  untilNow?: boolean | null;
  company?: string | null;
  job?: string | null;
  startMonth?: any | null;
  endMonth?: any | null;
  description?: string | null;
  location?: string | null;
  partTime?: boolean | null;
  miningExperience?: boolean | null;
  groupExperience?: boolean | null;
  industry?: DicIndustry | null;
  years?: number | null;
  months?: number | null;
  days?: number | null;
  requestStatus?: DicRequestStatus | null;
  attachments?: FileDescriptor[] | null;
}
export type PersonExperienceRequestViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "personExperienceRequest-browseView";
export type PersonExperienceRequestView<
  V extends PersonExperienceRequestViewName
> = V extends "_base"
  ? Pick<
      PersonExperienceRequest,
      | "id"
      | "requestNumber"
      | "requestDate"
      | "untilNow"
      | "company"
      | "job"
      | "startMonth"
      | "endMonth"
      | "description"
      | "location"
      | "partTime"
      | "miningExperience"
      | "groupExperience"
      | "years"
      | "months"
      | "days"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "comment"
    >
  : V extends "_local"
  ? Pick<
      PersonExperienceRequest,
      | "id"
      | "untilNow"
      | "company"
      | "job"
      | "startMonth"
      | "endMonth"
      | "description"
      | "location"
      | "partTime"
      | "miningExperience"
      | "groupExperience"
      | "years"
      | "months"
      | "days"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "requestNumber"
      | "requestDate"
      | "comment"
    >
  : V extends "_minimal"
  ? Pick<PersonExperienceRequest, "id" | "requestNumber" | "requestDate">
  : V extends "personExperienceRequest-browseView"
  ? Pick<
      PersonExperienceRequest,
      | "id"
      | "attachments"
      | "startMonth"
      | "endMonth"
      | "job"
      | "company"
      | "organizationBin"
      | "location"
      | "personGroup"
    >
  : never;
